import { styled } from '../../../shared/theming-sc'

const KebabItem = styled.a`
    color: black;
    display: inline-block;
    width: 100%;
    padding-bottom: 10px;
    text-align: left;

    &:last-child{
        padding-bottom: 0
    }
`

export {KebabItem}
